import { useCallback } from 'react';

function applyRef(ref, value) {
  if (value) {
    if (typeof ref === "function") {
      ref(value);
    } else if (ref && "current" in ref) {
      ref.current = value;
    }
  }
}
function mergeRefs(value, ...refs) {
  for (const ref of refs) {
    applyRef(ref, value);
  }
}
function useRefs(...refs) {
  return useCallback((value) => mergeRefs(value, ...refs), [refs]);
}

export { useRefs };
//# sourceMappingURL=use-refs.mjs.map
